import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import FarmerService from "../services/farmerService";

const defaultFarmerState = {
  farmerLoading: false,
  farmerData: null,
  farmerError: null,
};

const defaultGetFarmerState = {
  farmerGetLoading: false,
  farmerGetData: null,
  farmerGetError: null,
};

const defaultFarmInspectionState = {
  farmerFarmInspectionLoading: false,
  farmerFarmInspectionData: null,
  farmerFarmInspectionError: null,
};

const defaultUpdateFarmInspectionState = {
  updateFarmerFarmInspectionLoading: false,
  updateFarmerFarmInspectionData: null,
  updateFarmerFarmInspectionError: null,
};

const defaultGetFarmInspectionState = {
  farmerGetFarmInspectionLoading: false,
  farmerGetFarmInspectionData: null,
  farmerGetFarmInspectionError: null,
};

const defaultFarmHarvestingState = {
  farmerFarmHarvestingLoading: false,
  farmerFarmHarvestingData: null,
  farmerFarmHarvestingError: null,
};

const defaultGetFarmHarvestingState = {
  farmerGetFarmHarvestingLoading: false,
  farmerGetFarmHarvestingData: null,
  farmerHarvestingGetData: null,
  farmerGetFarmHarvestingError: null,
};

const defaultGetFarmerDetailsByIdState = {
  farmerGetLoading: false,
  farmerGetData: null,
  farmerGetError: null,
};

const defaultUpdateFarmerState = {
  farmerUpdateLoading: false,
  farmerUpdateData: null,
  farmerUpdateError: null,
};

const defaultFarmerPhotoState = {
  farmerPhotoLoading: false,
  farmerPhotoData: null,
  farmerPhotoError: null,
};

const defaultUpdateFarmHarvestingState = {
  updateFarmerFarmHarvestingLoading: false,
  updateFarmerFarmHarvestingData: null,
  updateFarmerFarmHarvestingError: null,
};

const defaultSendToFermenState = {
  sendToFermenLoading: false,
  sendToFermenData: null,
  sendToFermenError: null,
};

const fetchCreateFarmerData = createAsyncThunk(
  "farmer/create",
  async (farmeReq) => {
    return await FarmerService.createFarmerApi(farmeReq);
  },
);

const fetchGetFarmerData = createAsyncThunk("farmer/get", async (farmeReq) => {
  return await FarmerService.getFarmerApi(farmeReq);
});

const fetchCreateFarmInspectionData = createAsyncThunk(
  "farminspection/create",
  async (inspectionReq) => {
    return await FarmerService.createFarmInspection(inspectionReq);
  },
);

const updateFarmInspectionData = createAsyncThunk(
  "farminspection/update",
  async (inspectionReq) => {
    return await FarmerService.updateFarmInspection(inspectionReq);
  },
);

const fetchGetFarmInspectionData = createAsyncThunk(
  "farminspection/filter",
  async (inspectionReq) => {
    return await FarmerService.getFarmInspection(inspectionReq);
  },
);

const fetchCreateFarmHarvestingData = createAsyncThunk(
  "harvesting/create",
  async (inspectionReq) => {
    return await FarmerService.createHarvesting(inspectionReq);
  },
);

const fetchGetFarmHarvestingData = createAsyncThunk(
  "harvesting/filter",
  async (inspectionReq) => {
    return await FarmerService.getFarmHarvesting(inspectionReq);
  },
);

const updateFarmHarvestingData = createAsyncThunk(
  "harvesting/update",
  async (inspectionReq) => {
    return await FarmerService.updateHarvesting(inspectionReq);
  },
);

const fetchFarmerDetailsById = createAsyncThunk(
  "farmer/farmerdetails",
  async (farmerId) => {
    return await FarmerService.getFarmerDetailsById(farmerId);
  },
);

const updateFarmerDetails = createAsyncThunk(
  "farmer/update",
  async (farmeDataReq) => {
    return await FarmerService.updateFarmerDetails(farmeDataReq);
  },
);

const fetchFarmerPhotoData = createAsyncThunk(
  "farmer/photo",
  async (userReq) => {
    return await FarmerService.uploadFarmerPhoto(userReq);
  },
);

const fetchSendToFermentation = createAsyncThunk(
  "harvesting/sendToFermentation",
  async (harvestingReq) => {
    return await FarmerService.sendToFermentation(harvestingReq);
  },
);

const farmerCreateReducer = createSlice({
  name: "createFarmer",
  initialState: defaultFarmerState,
  extraReducers: (builder) => {
    builder.addCase(fetchCreateFarmerData.pending, (state) => {
      state.farmerLoading = true;
    });
    builder.addCase(fetchCreateFarmerData.fulfilled, (state, action) => {
      state.farmerLoading = false;
      state.farmerData = action.payload;
      state.farmerError = "";
    });
    builder.addCase(fetchCreateFarmerData.rejected, (state, action) => {
      state.farmerLoading = false;
      state.farmerData = null;
      state.farmerError = action.error.message;
    });
  },
});

const farmerGetReducer = createSlice({
  name: "getFarmer",
  initialState: defaultGetFarmerState,
  extraReducers: (builder) => {
    builder.addCase(fetchGetFarmerData.pending, (state) => {
      state.farmerGetLoading = true;
    });
    builder.addCase(fetchGetFarmerData.fulfilled, (state, action) => {
      state.farmerGetLoading = false;
      state.farmerGetData = action.payload;
      state.farmerGetError = "";
    });
    builder.addCase(fetchGetFarmerData.rejected, (state, action) => {
      state.farmerGetLoading = false;
      state.farmerGetData = null;
      state.farmerGetError = action.error.message;
    });
  },
});

const farmerCreateInspectionReducer = createSlice({
  name: "createFarmInspection",
  initialState: defaultFarmInspectionState,
  extraReducers: (builder) => {
    builder.addCase(fetchCreateFarmInspectionData.pending, (state) => {
      state.farmerFarmInspectionLoading = true;
    });
    builder.addCase(
      fetchCreateFarmInspectionData.fulfilled,
      (state, action) => {
        state.farmerFarmInspectionLoading = false;
        state.farmerFarmInspectionData = action.payload;
        state.farmerFarmInspectionError = "";
      },
    );
    builder.addCase(fetchCreateFarmInspectionData.rejected, (state, action) => {
      state.farmerFarmInspectionLoading = false;
      state.farmerFarmInspectionData = null;
      state.farmerFarmInspectionError = action.error.message;
    });
  },
});

const farmerUpdateInspectionReducer = createSlice({
  name: "updateFarmInspection",
  initialState: defaultUpdateFarmInspectionState,
  extraReducers: (builder) => {
    builder.addCase(updateFarmInspectionData.pending, (state) => {
      state.updateFarmerFarmInspectionLoading = true;
    });
    builder.addCase(updateFarmInspectionData.fulfilled, (state, action) => {
      state.updateFarmerFarmInspectionLoading = false;
      state.updateFarmerFarmInspectionData = action.payload;
      state.updateFarmerFarmInspectionError = "";
    });
    builder.addCase(updateFarmInspectionData.rejected, (state, action) => {
      state.updateFarmerFarmInspectionLoading = false;
      state.updateFarmerFarmInspectionData = null;
      state.updateFarmerFarmInspectionError = action.error.message;
    });
  },
});

const farmerInspectionListReducer = createSlice({
  name: "getInspectionList",
  initialState: defaultGetFarmInspectionState,
  extraReducers: (builder) => {
    builder.addCase(fetchGetFarmInspectionData.pending, (state) => {
      state.farmerGetFarmInspectionLoading = true;
    });
    builder.addCase(fetchGetFarmInspectionData.fulfilled, (state, action) => {
      state.farmerGetFarmInspectionLoading = false;
      state.farmerGetFarmInspectionData = action.payload;
      state.farmerGetFarmInspectionError = "";
    });
    builder.addCase(fetchGetFarmInspectionData.rejected, (state, action) => {
      state.farmerGetFarmInspectionLoading = false;
      state.farmerGetFarmInspectionData = null;
      state.farmerGetFarmInspectionError = action.error.message;
    });
  },
});

const farmerCreateHarvestingReducer = createSlice({
  name: "createHarvesting",
  initialState: defaultFarmHarvestingState,
  extraReducers: (builder) => {
    builder.addCase(fetchCreateFarmHarvestingData.pending, (state) => {
      state.farmerFarmHarvestingLoading = true;
    });
    builder.addCase(
      fetchCreateFarmHarvestingData.fulfilled,
      (state, action) => {
        state.farmerFarmHarvestingLoading = false;
        state.farmerFarmHarvestingData = action.payload;
        state.farmerFarmHarvestingError = "";
      },
    );
    builder.addCase(fetchCreateFarmHarvestingData.rejected, (state, action) => {
      state.farmerFarmHarvestingLoading = false;
      state.farmerFarmHarvestingData = null;
      state.farmerFarmHarvestingError = action.error.message;
    });
  },
});

const farmerHarvestingListReducer = createSlice({
  name: "getHarvestingList",
  initialState: defaultGetFarmHarvestingState,
  extraReducers: (builder) => {
    builder.addCase(fetchGetFarmHarvestingData.pending, (state) => {
      state.farmerGetFarmHarvestingLoading = true;
    });
    builder.addCase(fetchGetFarmHarvestingData.fulfilled, (state, action) => {
      state.farmerGetFarmHarvestingLoading = false;
      state.farmerGetFarmHarvestingData = action.payload;
      state.farmerHarvestingGetData = action.payload;
      state.farmerGetFarmHarvestingError = "";
    });
    builder.addCase(fetchGetFarmHarvestingData.rejected, (state, action) => {
      state.farmerGetFarmHarvestingLoading = false;
      state.farmerGetFarmHarvestingData = null;
      state.farmerHarvestingGetData = null;
      state.farmerGetFarmHarvestingError = action.error.message;
    });
  },
});

const getFarmerDetailsByIdReducer = createSlice({
  name: "farmerdetails",
  initialState: defaultGetFarmerDetailsByIdState,
  extraReducers: (builder) => {
    builder.addCase(fetchFarmerDetailsById.pending, (state) => {
      state.farmerGetLoading = true;
    });
    builder.addCase(fetchFarmerDetailsById.fulfilled, (state, action) => {
      state.farmerGetLoading = false;
      state.farmerGetData = action.payload;
      state.farmerGetError = "";
    });
    builder.addCase(fetchFarmerDetailsById.rejected, (state, action) => {
      state.farmerGetLoading = false;
      state.farmerGetData = null;
      state.farmerGetError = action.error.message;
    });
  },
});

const farmerUpdateDetailsReducer = createSlice({
  name: "updateFarmerDetails",
  initialState: defaultUpdateFarmerState,
  extraReducers: (builder) => {
    builder.addCase(updateFarmerDetails.pending, (state) => {
      state.farmerUpdateLoading = true;
    });
    builder.addCase(updateFarmerDetails.fulfilled, (state, action) => {
      state.farmerUpdateLoading = false;
      state.farmerUpdateData = action.payload;
      state.farmerUpdateError = "";
    });
    builder.addCase(updateFarmerDetails.rejected, (state, action) => {
      state.farmerUpdateLoading = false;
      state.farmerUpdateData = null;
      state.farmerUpdateError = action.error.message;
    });
  },
});

const farmerPhotoReducer = createSlice({
  name: "farmerPhoto",
  initialState: defaultFarmerPhotoState,
  extraReducers: (builder) => {
    builder.addCase(fetchFarmerPhotoData.pending, (state) => {
      state.farmerPhotoLoading = true;
    });
    builder.addCase(fetchFarmerPhotoData.fulfilled, (state, action) => {
      state.farmerPhotoLoading = false;
      state.farmerPhotoData = action.payload;
      state.farmerPhotoError = "";
    });
    builder.addCase(fetchFarmerPhotoData.rejected, (state, action) => {
      state.farmerPhotoLoading = false;
      state.farmerPhotoData = null;
      state.farmerPhotoError = action.error.message;
    });
  },
});

const farmerUpdateHarvestingReducer = createSlice({
  name: "updateFarmHarvesting",
  initialState: defaultUpdateFarmHarvestingState,
  extraReducers: (builder) => {
    builder.addCase(updateFarmHarvestingData.pending, (state) => {
      state.updateFarmerFarmHarvestingLoading = true;
    });
    builder.addCase(updateFarmHarvestingData.fulfilled, (state, action) => {
      state.updateFarmerFarmHarvestingLoading = false;
      state.updateFarmerFarmHarvestingData = action.payload;
      state.updateFarmerFarmHarvestingError = "";
    });
    builder.addCase(updateFarmHarvestingData.rejected, (state, action) => {
      state.updateFarmerFarmHarvestingLoading = false;
      state.updateFarmerFarmHarvestingData = null;
      state.updateFarmerFarmHarvestingError = action.error.message;
    });
  },
});

const farmerSendToFermentationReducer = createSlice({
  name: "sendToFermentation",
  initialState: defaultSendToFermenState,
  extraReducers: (builder) => {
    builder.addCase(fetchSendToFermentation.pending, (state) => {
      state.sendToFermenLoading = true;
    });
    builder.addCase(fetchSendToFermentation.fulfilled, (state, action) => {
      state.sendToFermenLoading = false;
      state.sendToFermenData = action.payload;
      state.sendToFermenError = "";
    });
    builder.addCase(fetchSendToFermentation.rejected, (state, action) => {
      state.sendToFermenLoading = false;
      state.sendToFermenData = null;
      state.sendToFermenError = action.error.message;
    });
  },
});

export const FarmerCreateReducer = farmerCreateReducer.reducer;
export const FarmerGetReducer = farmerGetReducer.reducer;
export const FarmerCreateInspectionReducer =
  farmerCreateInspectionReducer.reducer;
export const FarmerUpdateInspectionReducer =
  farmerUpdateInspectionReducer.reducer;
export const FarmerInspectionListReducer = farmerInspectionListReducer.reducer;
export const FarmerCreateHarvestingReducer =
  farmerCreateHarvestingReducer.reducer;
export const FarmerHarvestingListReducer = farmerHarvestingListReducer.reducer;
export const FarmerUpdateHarvestingReducer =
  farmerUpdateHarvestingReducer.reducer;
export const FarmerSendToFermentationReducer =
  farmerSendToFermentationReducer.reducer;
export const FarmerDetailsById = getFarmerDetailsByIdReducer.reducer;
export const FarmerUpdateDetailsReducer = farmerUpdateDetailsReducer.reducer;
export const FarmerPhotoReducer = farmerPhotoReducer.reducer;

export const FetchCreateFarmerData = fetchCreateFarmerData;
export const FetchGetFarmerData = fetchGetFarmerData;
export const FetchCreateFarmInspectionData = fetchCreateFarmInspectionData;
export const UpdateFarmInspectionData = updateFarmInspectionData;
export const FetchGetFarmInspectionData = fetchGetFarmInspectionData;
export const FetchGetFarmHarvestingData = fetchGetFarmHarvestingData;
export const FetchFarmerDetailsById = fetchFarmerDetailsById;
export const UpdateFarmerDetails = updateFarmerDetails;
export const FetchFarmerPhotoData = fetchFarmerPhotoData;
export const FetchCreateFarmHarvestingData = fetchCreateFarmHarvestingData;
export const FetchSendToFermentation = fetchSendToFermentation;
export const UpdateFarmHarvestingData = updateFarmHarvestingData;
